import { useState } from 'react';
import { AppWidgetProps } from '../types/common';

export function useCheckoutLoader({ isCheckoutDataInitialized }: Pick<AppWidgetProps, 'isCheckoutDataInitialized'>) {
  const [isCheckoutComponentLoaded, setIsCheckoutComponentLoaded] = useState(false);
  return { shouldShowLoader: !isCheckoutDataInitialized || !isCheckoutComponentLoaded, setIsCheckoutComponentLoaded };
}
